document.addEventListener("DOMContentLoaded", function () {
    // Detect if on mobile (you can adjust the width threshold if needed)
    if (window.innerWidth <= 768) {
      const h2 = document.querySelector(".slider_content_text h2");
      const link = document.querySelector(".slider_content_text a");

      if (h2) h2.textContent = "SUMMER SALE";
      if (link) link.href = "https://babyphat.com/collections/heritage-baby-tee-and-micro-short-bundles";
    }
});

